import { post } from "@services/apiService.js";

export default {
  refreshToken() {
    return post(`/v4/auth/v1/manage-site/admin/refresh`, {
      accessToken: localStorage.getItem('apiToken'),
      refreshToken: localStorage.getItem('refreshToken'),
    })
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        throw error;
      });
  },
}